import React, { useState } from 'react';
import './App.css';
import ChartGuysRepository from './ChartGuysRepository';
import ToolsPage from './ToolsPage';
import FourFaces from './FourFaces';

// Environment variables
const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME || 'Just a chart guy';
const TOKEN_SYMBOL = process.env.REACT_APP_TOKEN_SYMBOL || '$CHARTGUY';
const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS || 'HFyN8wr8B9AY5VeWgWTaWxSowVjpkXnDjPJ7DJUrpump';
const TOTAL_SUPPLY = process.env.REACT_APP_TOTAL_SUPPLY || '1000000000';
const TWITTER_URL = process.env.REACT_APP_TWITTER_URL || 'https://x.com/i/communities/1993060905194573838';
const CHART_URL = process.env.REACT_APP_CHART_URL || 'https://dexscreener.com/solana/3ge5bes24pu46ht7czfhssucrmjlc8vduq97fypgmpvq';
const BUY_URL = process.env.REACT_APP_BUY_URL || 'https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=HFyN8wr8B9AY5VeWgWTaWxSowVjpkXnDjPJ7DJUrpump'; // Placeholder - will be updated
const DEX_CHART_URL = process.env.REACT_APP_DEX_CHART_URL || 'https://dexscreener.com/solana/3ge5bes24pu46ht7czfhssucrmjlc8vduq97fypgmpvq'; // Placeholder - will be updated

// Chart Guy Images (from provided assets)
const CHARTGUY_SITTING = 'https://customer-assets.emergentagent.com/job_8583b7fb-7a05-41d6-81f2-f8b88292addf/artifacts/5qk4zpyq_JCG%20PFP%20750x.png';
const CHARTGUY_STANDING = 'https://customer-assets.emergentagent.com/job_8583b7fb-7a05-41d6-81f2-f8b88292addf/artifacts/871qzr27_ChartGuy_Standing.png';
const CHARTGUY_BANNER = 'https://customer-assets.emergentagent.com/job_8583b7fb-7a05-41d6-81f2-f8b88292addf/artifacts/htb4jkmc_CG%20Banner%20Table%20w-Legs.png';

function App() {
  const [copied, setCopied] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'repository', or 'tools'

  const copyToClipboard = () => {
    navigator.clipboard.writeText(CONTRACT_ADDRESS);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const navigateToRepository = () => {
    setCurrentPage('repository');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const navigateToTools = () => {
    setCurrentPage('tools');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const navigateToHome = () => {
    setCurrentPage('home');
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  // Show Repository page
  if (currentPage === 'repository') {
    return <ChartGuysRepository onNavigateHome={navigateToHome} />;
  }

  // Show Tools page
  if (currentPage === 'tools') {
    return <ToolsPage onNavigateHome={navigateToHome} />;
  }

  // Show Home page
  return (
    <div className="App">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-chartguy-dark/95 backdrop-blur-md border-b border-chartguy-yellow/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-2">
              <img src={CHARTGUY_SITTING} alt="Chart Guy" className="h-10 w-10 rounded-full" />
              <span className="text-xl font-display font-bold text-chartguy-yellow">CHARTGUY</span>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-chartguy-yellow transition">About</button>
              <button onClick={navigateToRepository} className="text-gray-300 hover:text-chartguy-yellow transition">ChartGuys</button>
              <button onClick={navigateToTools} className="text-gray-300 hover:text-chartguy-yellow transition">Tools</button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-300 hover:text-chartguy-yellow transition">FAQ</button>
              <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="bg-chartguy-yellow text-chartguy-dark px-6 py-2 rounded-full font-semibold hover:bg-chartguy-brown hover:text-white transition">Join Community</a>
            </div>

            {/* Mobile menu button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-chartguy-yellow">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-chartguy-dark/98 border-t border-chartguy-yellow/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button onClick={() => scrollToSection('about')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-chartguy-yellow transition">About</button>
              <button onClick={navigateToRepository} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-chartguy-yellow transition">ChartGuys</button>
              <button onClick={navigateToTools} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-chartguy-yellow transition">Tools</button>
              <button onClick={() => scrollToSection('faq')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-chartguy-yellow transition">FAQ</button>
              <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="block w-full text-center mt-2 bg-chartguy-yellow text-chartguy-dark px-6 py-2 rounded-full font-semibold">Join Community</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="min-h-screen flex items-center justify-center relative overflow-hidden pt-16" style={{background: 'linear-gradient(135deg, #2D2D2D 0%, #1a1a1a 100%)'}}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-chartguy-yellow rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-chartguy-brown rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <div className="animate-float mb-8">
            <img src={CHARTGUY_BANNER} alt="Just a Chart Guy" className="mx-auto max-w-md w-full" data-testid="hero-banner-image" />
          </div>
          
          <h1 className="text-5xl md:text-7xl font-display font-bold mb-6" data-testid="hero-title">
            <span className="gradient-text">JUST A CHART GUY</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto" data-testid="hero-tagline">
            Turning market obsession into a superpower
          </p>
          
          <div className="hero-contract-container rounded-xl max-w-2xl mx-auto">
            <p className="text-sm text-gray-400 mb-2">Contract Address (CA)</p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <code className="text-chartguy-yellow font-mono text-sm md:text-base break-all" data-testid="contract-address">{CONTRACT_ADDRESS}</code>
              <button 
                onClick={copyToClipboard}
                className="copy-button bg-chartguy-yellow text-chartguy-dark px-4 py-2 rounded-lg font-semibold hover:bg-chartguy-brown hover:text-white transition"
                data-testid="copy-address-button"
              >
                {copied ? '✓ Copied!' : 'Copy'}
              </button>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center flex-wrap">
            <a href={BUY_URL} target="_blank" rel="noopener noreferrer" className="cta-primary bg-chartguy-yellow text-chartguy-dark px-10 py-4 rounded-full text-lg hover:bg-chartguy-brown hover:text-white w-full sm:w-auto max-w-xs" data-testid="buy-chartguy-button">Buy ChartGuy</a>
            <a href={DEX_CHART_URL} target="_blank" rel="noopener noreferrer" className="cta-secondary border-2 border-chartguy-yellow text-chartguy-yellow px-10 py-4 rounded-full text-lg hover:bg-chartguy-yellow hover:text-chartguy-dark w-full sm:w-auto max-w-xs" data-testid="dex-chart-button">Dex Chart</a>
            <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="cta-secondary border-2 border-chartguy-yellow text-chartguy-yellow px-10 py-4 rounded-full text-lg hover:bg-chartguy-yellow hover:text-chartguy-dark w-full sm:w-auto max-w-xs" data-testid="join-community-button">Join Community</a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section-container bg-gradient-to-b from-chartguy-dark to-black" data-testid="about-section">
        <div className="content-grid">
          <div>
            <img src={CHARTGUY_STANDING} alt="Chart Guy Standing" className="rounded-2xl shadow-2xl" data-testid="about-image" />
          </div>
          <div>
            <h2 className="section-title gradient-text" data-testid="about-title">Who is Chart Guy?</h2>
            <div className="space-y-6 body-text text-gray-300">
              <p>
                Chart Guy lives in the space between "this is gambling" and "wait, I see a pattern." We're your friend who texts resistance levels instead of good morning. The coworker with 47 browser tabs open. The voice saying "zoom out" when everyone else is panicking.
              </p>
              <p>
                Some chase gains. We chase understanding. And yeah, sometimes they're the same thing, but mostly we're here because the market speaks a language we can't help but try to decode.
              </p>
              <p>
                Chart Guy is that shared frequency only we can hear. The 2am wakeup that's somehow both a problem and the solution. Different approaches, same addiction. And underneath it all, the stubborn belief that if we stare long enough, draw enough lines, refresh enough times, the chaos might actually start making sense.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Four Faces of Chart Guy Section */}
      <FourFaces />

      {/* What is the Chart Guy Project Section */}
      <section className="section-container bg-black" data-testid="project-section">
        <div className="max-w-5xl mx-auto">
          <h2 className="section-title gradient-text text-center" data-testid="project-title">
            What is the Chart Guy Project?
          </h2>
          
          <div className="space-y-6 body-text text-gray-300">
            <p>
              Every trader we know has the same disease. Different symptoms, same condition. We check charts at dinner. Dream in candlesticks. Have more indicators than friends.
            </p>
            
            <p>
              So we built a home for it.
            </p>
            
            <p>
              Chart Guy started as a meme because that's what we needed: recognition. A mirror held up to our shared obsession. Not another utility token. Not another protocol. Just the truth: we're all chart guys, and that's worth something.
            </p>
            
            <p>
              Charts are the only honest thing left in markets. No narrative. No spin. Just data trying to tell you something if you're obsessed enough to listen. That obsession is what unites us. Whether you're a TradFi analyst with Bloomberg Terminal PTSD or a crypto degen drawing fibs on $50k mc memecoins, if you see patterns where others see chaos, you're one of us.
            </p>
            
            <p>
              Now we're evolving. Not because we have to, but because we can't help ourselves. We're building small tools for the problems only chart guys understand. Discovery tools for when you have 200 tickers but can't find the one that matters. Focus filters for ADHD-fueled trading sessions. Habit trackers that don't judge your 3 AM futures check.
            </p>
            
            <p>
              No roadmap. No promises. Just chart guys building for chart guys, one small fix at a time.
            </p>
            
            <p className="text-center pt-6 border-t border-chartguy-yellow/20">
              The meme is the foundation. The tools are just us scratching our own itch. The community is everyone who gets why this exists without us having to explain it.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="section-container bg-gradient-to-b from-chartguy-dark to-black" data-testid="faq-section">
        <div className="text-center mb-12">
          <h2 className="section-title gradient-text" data-testid="faq-title">Frequently Asked Questions</h2>
        </div>
        
        <div className="faq-grid">
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">What is {TOKEN_SYMBOL}?</h3>
            <p className="text-gray-300">{TOKEN_SYMBOL} is a memecoin for everyone who can't stop staring at candles. It's not about utility or promises, it's about finally having a token that represents what we actually do all day. Think of it as a digital badge of honor for your chart addiction.</p>
          </div>
          
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">Is this an investment?</h3>
            <p className="text-gray-300">Absolutely not. {TOKEN_SYMBOL} is a meme, not a retirement plan. If you're looking for financial advice, ask your actual financial advisor (or better yet, check the charts yourself). This is about identity, not ROI. DYOR, NFA, and all that.</p>
          </div>
          
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">How do I buy {TOKEN_SYMBOL}?</h3>
            <p className="text-gray-300">Same way you buy anything on Solana: Get a wallet (Phantom's fine), buy SOL, find us on Jupiter or Raydium. You know the drill. If you don't, you're probably not a chart guy yet, but stick around, you'll learn.</p>
          </div>
          
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">Is there a team?</h3>
            <p className="text-gray-300">There's no "team" because Chart Guy isn't one person, it's all of us. We're the collective consciousness of everyone who texts support levels at 2am. The anonymous educators. The pattern obsessed. The ones who never log off.</p>
          </div>
          
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">What are the tokenomics?</h3>
            <p className="text-gray-300">1 billion tokens. No complicated vesting schedules. No "innovative deflationary mechanisms." Just a billion tokens for a billion chart guys. Simple, like a clean breakout.</p>
          </div>
          
          <div className="faq-item rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-chartguy-yellow mb-3">How can I get involved?</h3>
            <p className="text-gray-300">You already are. But if you want to go deeper: join the community, share your charts, argue about timeframes, and help us build tools for our shared obsession. Most importantly, keep doing what you're already doing, staring at charts way too much.</p>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="section-container bg-black" data-testid="community-section">
        <div className="text-center">
          <h2 className="section-title gradient-text" data-testid="community-title">Join the Community</h2>
          <p className="text-gray-400 text-lg mb-8">Connect with fellow chart enthusiasts and educators</p>
          
          <div className="flex justify-center gap-6 mb-8">
            <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="bg-chartguy-dark border-2 border-chartguy-yellow/30 hover:border-chartguy-yellow rounded-full p-4 transition group" data-testid="twitter-link">
              <svg className="w-8 h-8 text-chartguy-yellow" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
          
          <p className="text-sm text-gray-500 italic">"Still charting, rain or shine"</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-chartguy-dark border-t border-chartguy-yellow/20 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img src={CHARTGUY_SITTING} alt="Chart Guy" className="h-10 w-10 rounded-full" />
                <span className="text-xl font-display font-bold text-chartguy-yellow">CHARTGUY</span>
              </div>
              <p className="text-gray-400 text-sm">The memecoin for market educators who keep showing up.</p>
            </div>
            
            <div>
              <h4 className="text-chartguy-yellow font-semibold mb-4">Quick Links</h4>
              <div className="space-y-2 text-sm">
                <button onClick={() => scrollToSection('about')} className="block text-gray-400 hover:text-chartguy-yellow transition">About</button>
                <button onClick={navigateToRepository} className="block text-gray-400 hover:text-chartguy-yellow transition">ChartGuys</button>
                <button onClick={navigateToTools} className="block text-gray-400 hover:text-chartguy-yellow transition">Tools</button>
                <button onClick={() => scrollToSection('faq')} className="block text-gray-400 hover:text-chartguy-yellow transition">FAQ</button>
              </div>
            </div>
            
            <div>
              <h4 className="text-chartguy-yellow font-semibold mb-4">Community</h4>
              <div className="space-y-2 text-sm">
                <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="block text-gray-400 hover:text-chartguy-yellow transition">Twitter/X</a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-chartguy-yellow/20 pt-8">
            <div className="bg-yellow-900/20 border border-yellow-600/30 rounded-lg p-4 mb-6">
              <p className="text-yellow-200 text-sm text-center">
                <strong>⚠️ Disclaimer:</strong> {TOKEN_SYMBOL} is a memecoin for entertainment and community purposes only. This is NOT financial advice. This token is NOT an investment or security. Cryptocurrency trading carries significant risk. Always DYOR (Do Your Own Research) before making any decisions.
              </p>
            </div>
            
            <div className="text-center text-gray-500 text-sm">
              <p>© 2025 ChartGuy. All rights reserved.</p>
              <p className="mt-2">Contract: <code className="text-chartguy-yellow">{CONTRACT_ADDRESS}</code></p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
